import moment from 'moment';
import { ISearchResult } from './i-search-result';

export class SearchResult {
  resultId: number;
  userId: number;
  status: string;
  resultName: string;
  documentName: string;
  submittedTime: Date;
  expirationTime: Date;
  resultSize: number;
  outputType: string;

  constructor(searchResultData: ISearchResult) {
    this.expirationTime = new Date(searchResultData.expirationTime);
    this.submittedTime = new Date(searchResultData.submittedTime);

    this.resultId = searchResultData.resultId;
    this.userId = searchResultData.userId;
    this.status = searchResultData.status;
    this.resultName = searchResultData.resultName;
    this.documentName = searchResultData.documentName;
    this.resultSize = searchResultData.resultSize;
    this.outputType = searchResultData.outputType;
  }

  get formattedExpirationTime(): string {
    return moment(this.submittedTime).format('MM/DD/YYYY h:mm A');
  }

  get statusIcon(): string {
    if (this.status.toUpperCase() === 'FAILED') {
      return 'text-bg-danger';
    }
    if (this.status.toUpperCase() === 'PENDING') {
      return 'text-bg-warning';
    }
    if (this.status.toUpperCase() === 'NEW') {
      return 'text-bg-info';
    }
    if (this.status.toUpperCase() === 'EXISTS') {
      return 'd-none';
    }
    return '';
  }
}
